import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()(theme => ({
  helperText: { margin: theme.spacing(0.5, 1, 0.75, 1), padding: 0, lineHeight: 1 },
}));
